"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.default = exports.StructuredTable = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _FemaGoTable = _interopRequireDefault(require("./tables/femaGoTable/FemaGoTable"));
var _semanticUiReact = require("semantic-ui-react");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
//import {connectDynamic} from '../dynamic/dynamicComponent';

var StructuredTable = function StructuredTable(props) {
  var dynamicComponent = props.dynamicComponent,
    data = props.data,
    type = props.type,
    dataPath = props.dataPath,
    config = props.config,
    title = props.title,
    noDivider = props.noDivider,
    id = props.id,
    summary = props.summary;
  var gatherTerminalColumns = function gatherTerminalColumns(cols, acc) {
    cols.forEach(function (col) {
      if (col.subHeaders) {
        gatherTerminalColumns(col.subHeaders, acc);
      } else {
        acc.push(col);
      }
    });
  };
  var columns = _lodash.default.chain(_toConsumableArray(config.tableColumns)).reduce(function (result, year) {
    var order = _lodash.default.get(year, 'order');
    var header = order > 0 ? Number(_lodash.default.get(year, 'Header').substring(0, 4)) + (order - 1) : _lodash.default.get(year, 'Header');
    result.push({
      Header: header,
      order: order
    });
    return result;
  }, []).sortBy('order').value();
  var terminalColumns = [];
  gatherTerminalColumns(columns, terminalColumns);
  //console.log('columns st', columns)

  var rows = _toConsumableArray(config.tableRows).sort(function (a, b) {
    return a.order - b.order;
  });
  var totals = [];
  var sortedRows;
  sortedRows = rows.map(function (row, i) {
    if (row.transform === 'total') {
      return [row.title].concat(totals);
    } else {
      var cellValues = row.cellPaths.map(function (cellPath, i) {
        totals[i] = (totals[i] || 0) + _lodash.default.get(dynamicComponent, cellPath, _lodash.default.get(data, cellPath));
        return _lodash.default.get(dynamicComponent, cellPath, _lodash.default.get(data, cellPath, 0));
      });
      return [row.title].concat(_toConsumableArray(cellValues));
    }
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title ? /*#__PURE__*/_react.default.createElement("div", null, title) : null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default, {
    type: "static",
    summary: summary || 'data table'
  }, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Header, null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, {
    id: id || dataPath
  }, columns.map(function (column, index) {
    return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, {
      key: column['Header'] + index,
      className: 'header-cell',
      id: column['Header'],
      colSpan: column['colSpan'],
      type: index === 0 ? '' : 'number'
    }, column['Header']);
  })), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, {
    id: id || dataPath
  }, columns.map(function (column, index) {
    return column.subHeaders && column.subHeaders.map(function (sub, index) {
      return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, {
        key: sub['Header'] + index,
        className: 'subheader-cell',
        id: sub['Header'],
        type: index === 0 ? '' : 'number'
      }, sub['Header']);
    });
  }))), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Body, null, sortedRows && sortedRows.map(function (row, index) {
    return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, null, row.map(function (cell, index) {
      var _terminalColumns$inde;
      var type = (_terminalColumns$inde = terminalColumns[index]) === null || _terminalColumns$inde === void 0 ? void 0 : _terminalColumns$inde.type;
      return index === 0 ? /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
        id: index
      }, cell) : /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.NumberCell, {
        id: index,
        type: type
      }, cell);
    }));
  }))), !noDivider && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Divider, null));
};
exports.StructuredTable = StructuredTable;
var mapStateToProps = function mapStateToProps(state) {
  return {
    dynamicComponent: state.dynamicComponent
  };
};
exports.mapStateToProps = mapStateToProps;
var _default = (0, _reactRedux.connect)(mapStateToProps)(StructuredTable);
exports.default = _default;